import React from 'react';
import {
  FormControlLabel,
  Checkbox as MUICheckbox,
  CheckboxProps as MUICheckboxProps,
  FormHelperText,
  FormControl,
  styled
} from '@mui/material';

export interface CheckboxProps extends MUICheckboxProps {
  /** Checkbox label */
  label: React.ReactNode;
  /** Helper text */
  helperText?: React.ReactNode;
  /** Error state */
  error?: boolean;
  /** Error message */
  errorText?: string;
}

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  display: 'flex',
}));

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  helperText,
  error = false,
  errorText,
  ...rest
}) => {
  const displayHelperText = error && errorText ? errorText : helperText;

  return (
    <StyledFormControl error={error}>
      <FormControlLabel
        control={<MUICheckbox {...rest} />}
        label={label}
      />
      {displayHelperText && <FormHelperText>{displayHelperText}</FormHelperText>}
    </StyledFormControl>
  );
};

export default Checkbox;
